import { FC, PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { useIsAuthenticated } from '../../../hooks/useIsAuthenticated';
import { Box, PageWrapper } from '@oresundsbron/bridge-ui';
import AccountBanner from './AccountBanner';
import { useTranslation } from 'next-i18next';
import { Eq as StringEq } from 'fp-ts/lib/string';
import AccountContent from './AccountContent';
import { SEOMetadata } from '~/components/SEOMetadata';
import { LoadingSpinner, VerifyContactDetails } from '@oresundsbron/app-common';
import { BridgeStatusBanner } from '~/modules/TrafficInformation/BridgeStatusBanner';
import { InformationBanner } from '~/modules/InformationBanner';
import { OSBNavBar } from '~/modules/NavBar';
import Footer from '~/modules/Footer';

interface AccountLayoutProps {
  namespace: string;
  hideMetadata?: true;
  hideNavigation?: true;
}

const AccountLayout: FC<PropsWithChildren<AccountLayoutProps>> = ({
  children,
  namespace,
  hideMetadata,
  hideNavigation,
}) => {
  const { t } = useTranslation('account');
  const router = useRouter();
  const { authenticated, loading } = useIsAuthenticated();
  const isDashboardPage = router.asPath.includes('dashboard');

  if (loading) {
    return (
      <Box className="col-span-3 flex h-full flex-grow items-center justify-center">
        <LoadingSpinner className="m-auto" />
      </Box>
    );
  }

  if (authenticated) {
    return (
      <>
        <BridgeStatusBanner />
        <InformationBanner />
        <OSBNavBar />
        <SEOMetadata items={[]} />
        <PageWrapper className=" relative min-h-[calc(100dvh-180px)]">
          {!isDashboardPage && (
            <AccountBanner
              title={t('layout.title')}
              navigationLabel={t('navigation.dashboard')}
              dashboard={StringEq.equals(namespace, 'dashboard')}
            />
          )}
          {/* See https://dev.azure.com/oresundsbron/osb-web/_workitems/edit/9213/ why this is only done on private customers */}
          <VerifyContactDetails />

          <AccountContent
            namespace={namespace}
            hideNavigation={hideNavigation}
            hideMetadata={hideMetadata}
          >
            {children}
          </AccountContent>
        </PageWrapper>
        <Footer />
      </>
    );
  }

  return <></>;
};
export default AccountLayout;
